import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Fragment } from 'react';
import { TermsModal } from 'src/components/Terms/TermsModal';
import useDialog from 'src/helpers/hooks/useDialog';

export const complianceFormTermsTextStyles = {
  termsText: {
    color: '#777777',
    display: 'inline',
    fontSize: 12,
  },
  termsLink: {
    cursor: 'pointer',
    color: 'inherit',
  },
} as const;

export function ComplianceFormTermsText() {
  const {
    handleClose: closeTermsModal,
    handleOpen: openTermsModal,
    open: isOpenTermsModal,
  } = useDialog();

  return (
    <Fragment>
      <Typography sx={complianceFormTermsTextStyles.termsText} variant="body1">
        By clicking “Continue” I agree to the{' '}
        <Link
          role="button"
          id="TermsLink"
          onClick={openTermsModal}
          sx={complianceFormTermsTextStyles.termsLink}
        >
          Terms & Conditions
        </Link>{' '}
        and acknowledge receipt of and consent to our{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          sx={complianceFormTermsTextStyles.termsLink}
          href="https://www.theguarantors.com/notice-of-collection"
        >
          Notice of Collection
        </Link>{' '}
        and{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          sx={complianceFormTermsTextStyles.termsLink}
          href="https://www.theguarantors.com/privacy"
        >
          Privacy Policy
        </Link>
        , as well as our third party compliance platform{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          sx={complianceFormTermsTextStyles.termsLink}
          href="https://www.covie.com/legal/end-user-privacy"
        >
          Covie User Privacy Policy
        </Link>
        .
      </Typography>
      <TermsModal
        open={isOpenTermsModal}
        onClose={closeTermsModal}
        onOpen={openTermsModal}
        type="Compliance"
      />
    </Fragment>
  );
}

/*
                      <Typography display="inline">
                        By clicking “Continue” I agree to the{' '}
                        <Link
                          id="TermsLink"
                          onClick={handleOpen}
                          style={{ color: 'inherit', cursor: 'pointer' }}
                        >
                          Terms & Conditions
                        </Link>{' '}
                        and acknowledge receipt of and consent to our{' '}
                        <Link
                          target="_blank"
                          href="https://www.theguarantors.com/notice-of-collection"
                          style={{ color: 'inherit', cursor: 'pointer' }}
                        >
                          Notice of Collection
                        </Link>{' '}
                        and{' '}
                        <Link
                          target="_blank"
                          href="https://www.theguarantors.com/privacy"
                          style={{ color: 'inherit', cursor: 'pointer' }}
                        >
                          {' '}
                          Privacy Policy.
                        </Link>
                      </Typography>
*/
